import { Box, Container, Stack } from '@mui/material';

import { SignUp as SignupView } from '@modules/Auth/views';

export const Signup = () => {

  return (
    <Stack height="100vh" justifyContent="center">
      <Box py={6}>
        <Container maxWidth="md">
          <SignupView />
        </Container>
      </Box>
    </Stack>
  );
};
